
<template>
  <b-container fluid>
    <!-- Search Form -->
    <iq-card>
      <template v-slot:headerTitle>
          <h4 class="card-title">{{ $t('trainer_trainee.allowance') + ' ' + $t('globalTrans.search') }}</h4>
      </template>
      <template v-slot:body>
          <b-row>
            <b-col lg="6" sm="12">
                <b-form-group
                    class="row"
                    label-cols-sm="4"
                    label-for="fiscal_year_id"
                    >
                    <template v-slot:label>
                        {{ $t('globalTrans.fiscal_year') }}
                    </template>
                    <b-form-select
                        plain
                        v-model="search.fiscal_year_id"
                        id="fiscal_year_id"
                        :options="fiscalYearList"
                    >
                    <template v-slot:first>
                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                    </template>
                    </b-form-select>
                </b-form-group>
            </b-col>
            <b-col lg="6" sm="12">
              <b-form-group
                  class="row"
                  label-cols-sm="4"
                  label-for="circular_id"
                  >
                  <template v-slot:label>
                      {{ $t('trainer_trainee.circular_memo_no') }}
                  </template>
                  <b-form-select
                      plain
                      v-model="search.circular_id"
                      id="circular_id"
                      :options="circularMemoList"
                  >
                  <template v-slot:first>
                      <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                  </template>
                  </b-form-select>
              </b-form-group>
            </b-col>
            <b-col lg="6" sm="12">
              <b-form-group
                  class="row"
                  label-cols-sm="4"
                  label-for="training_name_id"
                  >
                  <template v-slot:label>
                      {{ $t('trainer_trainee.training_title') }}
                  </template>
                  <b-form-select
                      plain
                      v-model="search.training_name_id"
                      id="training_name_id"
                      :options="trainingTitleList"
                  >
                  <template v-slot:first>
                      <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                  </template>
                  </b-form-select>
              </b-form-group>
            </b-col>
            <b-col xs="12" sm="12" md="6">
              <b-spinner v-if="spinLoader" class="overlay" variant="success" small label="Spinning"></b-spinner>
                <b-form-group
                  class="row"
                  label-cols-sm="4"
                  label-for="batch_id"
                >
                  <template v-slot:label>
                    {{ $t('trainer_trainee.batch') }}
                  </template>
                  <b-form-select
                    plain
                    v-model="search.batch_id"
                    id="batch_id"
                    :options="batchList"
                  >
                    <template v-slot:first>
                      <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                    </template>
                  </b-form-select>
                </b-form-group>
            </b-col>
            <b-col cols="12" class="text-right">
              <b-button type="button" variant="primary" @click="searchData">{{ $t('globalTrans.search')}}</b-button>
            </b-col>
          </b-row>
      </template>
  </iq-card>
    <!-- /Search Form -->
    <b-row>
      <b-col md="12">
        <iq-card>
          <!-- Add New -->
          <template v-slot:headerTitle>
            <h4 class="card-title">{{ $t('trainer_trainee.allowances') + ' ' + $t('globalTrans.list')}}</h4>
          </template>
          <template v-slot:headerAction>
            <b-button variant="primary" v-b-modal.modal-4 @click="resetId">
              <i class="fas fa-plus"></i>{{ $t('globalTrans.add_new') }}
            </b-button>
          </template>
          <!-- /Add New -->
          <template v-slot:body>
            <b-overlay :show="loadingState">
              <b-row>
                <b-col md="12" class="table-responsive">
                  <!-- Table -->
                  <b-table thead-class="bg-primary" bordered hover :items="listData" :fields="columns" aria-hidden="loading | listReload ? 'true' : null" :emptyText="$t('globalTrans.noDataFound')" show-empty>
                    <template v-slot:cell(index)="data">
                      {{ $n(data.index + pagination.slOffset) }}
                    </template>
                     <template v-slot:cell(fiscal_year_id)="data">
                      {{ getFiscalYear(data.item.fiscal_year_id) }}
                    </template>
                     <template v-slot:cell(circular_publication_id)="data">
                         {{ getCircularMemo(data.item.circular_publication_id) }}
                    </template>
                     <template v-slot:cell(training_title)="data">
                         {{ getTraining(data.item.training_title_id) }}
                    </template>
                    <template v-slot:cell(batch_id)="data">
                         {{ getBatch(data.item.batch_id) }}
                    </template>
                      <template v-slot:cell(attachment)="data">
                          <a v-if="data.item.attachment" :href="baseUrl + 'download-attachment?file=uploads/allowance/attachment/'+data.item.attachment" class="btn_table_action btn_green" title="View Details">{{$t('globalTrans.download')}}</a>
                          <a v-else href="javascript:" class="btn_table_action btn_green" title="View Details" v-b-modal.modal-3 @click="details(data.item)"><i class="fas fa-upload"></i></a>
                      </template>
                     <template v-slot:cell(application_date)="data">
                         {{ data.item.application_date | dateFormat }}
                    </template>
                    <template v-slot:cell(status)="data">
                        <span class="badge badge-danger" v-if="data.item.status == 2">{{$t('globalTrans.inactive')}}</span>
                        <span class="badge badge-success" v-else>{{$t('globalTrans.active')}}</span>
                    </template>
                    <template v-slot:cell(action)="data">
                      <span class="d-flex">
                      <a href="javascript:" class="btn_table_action btn_green" title="View Details" v-b-modal.modal-detail @click="details(data.item)"><i class="fas fa-eye"></i></a>
                      <a href="javascript:" class="btn_table_action btn_blue" title="Edit" v-b-modal.modal-4 @click="edit(data.item)"><i class="ri-ball-pen-fill"></i></a>
                      </span>
                    </template>
                  </b-table>

                  <b-pagination
                    v-model="pagination.currentPage"
                    :per-page="pagination.perPage"
                    :total-rows="pagination.totalRows"
                    @input="searchData"
                    />
                </b-col>
              </b-row>
            </b-overlay>
          </template>
        </iq-card>
      </b-col>
    </b-row>
     <b-modal id="modal-4" size="xl" :title="formTitle"  :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
      <Form :item="item" :id="editItemId" :key="editItemId"/>
    </b-modal>
     <b-modal id="modal-detail" size="xl" :title="detailTitle"  :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
        <Details :item="item" :key="editItemId"/>
    </b-modal>
      <b-modal id="modal-3" size="md" :title="detailTitle"  :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
          <Attachment :item="item" :key="editItemId"/>
      </b-modal>
  </b-container>
</template>
<script>
import Form from './Form'
import Details from './Details'
import Attachment from './Attachment'
import RestApi, { trainingElearningServiceBaseUrl } from '../../../../../config/api_config'
import { allowanceListApi, trainerselectionStatus } from '../../api/routes'
import ModalBaseMasterList from '@/mixins/modal-base-master-list'

export default {
  mixins: [ModalBaseMasterList],
  components: {
    Form, Details, Attachment
  },
  data () {
    return {
      spinLoader: false,
      baseUrl: trainingElearningServiceBaseUrl,
      search: {
        fiscal_year_id: 0,
        circular_id: 0,
        training_name_id: 0,
        batch_id: 0
      },
      circularMemoList: [],
      trainingTitleList: [],
      batchList: [],
      tmpBatchList: [],
      editItemId: 0,
      item: ''
    }
  },
  watch: {
    'search.fiscal_year_id': function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.circularMemoList = this.getMomoList(newVal)
        this.search.circular_id = 0
        this.search.training_name_id = 0
        this.trainingTitleList = []
        this.search.batch_id = 0
        this.batchList = []
      }
    },
    'search.circular_id': function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.search.batch_id = 0
        this.batchList = []
        this.trainingTitleList = this.getTrainingTitle(newVal)
        this.getCircularData()
      }
    },
    currentLocale: function (newVal, oldVal) {
        if (newVal !== oldVal) {
            if (this.search.fiscal_year_id) {
                this.circularMemoList = this.getMomoList(this.search.fiscal_year_id)
            }
            if (this.search.circular_id) {
                this.trainingTitleList = this.getTrainingTitle(this.search.circular_id)
            }
            this.getBatchList()
        }
    }
  },
  computed: {
    formTitle () {
      return (this.editItemId === 0) ? this.$t('trainer_trainee.allowance') + ' ' + this.$t('trainer_trainee.selection') + ' ' + this.$t('globalTrans.entry') : this.$t('trainer_trainee.allowance') + ' ' + this.$t('globalTrans.modify')
    },
    detailTitle () {
      return this.$t('trainer_trainee.allowance') + ' ' + this.$t('trainer_trainee.selection') + ' ' + this.$t('globalTrans.details')
    },
    fiscalYearList: function () {
      return this.$store.state.commonObj.fiscalYearList.filter(item => item.status === 0)
    },
    columns () {
      const labels = [
        { label: this.$t('globalTrans.sl_no'), class: 'text-left' },
        { label: this.$t('globalTrans.fiscalYear'), class: 'text-left' },
        { label: this.$t('trainer_trainee.circular_memo_no'), class: 'text-left' },
        { label: this.$t('trainer_trainee.training_title'), class: 'text-left' },
        { label: this.$t('trainer_trainee.batch'), class: 'text-left' },
        { label: this.$t('elearning_config.application_date'), class: 'text-left' },
        { label: this.$t('trainer_trainee.attachment'), class: 'text-left' },
        { label: this.$t('globalTrans.action'), class: 'text-center' }
        ]
      let keys = []
      if (this.$i18n.locale === 'bn') {
        keys = [
          { key: 'index' },
          { key: 'fiscal_year_id' },
          { key: 'circular_publication_id' },
          { key: 'training_title' },
          { key: 'batch_id' },
          { key: 'application_date' },
          { key: 'attachment' },
          { key: 'action' }
        ]
      } else {
        keys = [
          { key: 'index' },
          { key: 'fiscal_year_id' },
          { key: 'circular_publication_id' },
          { key: 'training_title' },
          { key: 'batch_id' },
          { key: 'application_date' },
          { key: 'attachment' },
          { key: 'action' }
        ]
      }
      return labels.map((item, index) => {
        return Object.assign(item, keys[index])
      })
    },
    currentLocale () {
      return this.$i18n.locale
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    details (item) {
      this.item = item
      this.editItemId = item.id
    },
    resetId () {
      this.item = []
      this.editItemId = 0
    },
    edit (item) {
      this.item = item
      this.editItemId = item.id
    },
    searchData () {
      this.loadData()
    },
    remove (item) {
      this.changeStatus(trainingElearningServiceBaseUrl, trainerselectionStatus, item)
    },
    async getCircularData () {
        if (this.search.fiscal_year_id && this.search.circular_id) {
            this.spinLoader = true
            this.tmpBatchList = []
            const params = {
              fiscal_year_id: this.search.fiscal_year_id,
              circular_id: this.search.circular_id
            }
            const result = await RestApi.getData(trainingElearningServiceBaseUrl, 'training-plan-management/training-routine/circular-data', params)
            if (result.success) {
                if (result.training) {
                  this.search.training_name_id = result.training
                }
                this.tmpBatchList = result.batch
                this.getBatchList()
            }
            this.spinLoader = false
        }
    },
    getBatchList () {
      if (this.tmpBatchList.length > 0) {
        this.batchList = this.tmpBatchList.map((item, index) => {
            return Object.assign({}, { value: item.batch_d.id, text: this.$i18n.locale === 'en' ? item.batch_d.batch : item.batch_d.batch_bn })
        })
      } else {
        this.batchList = []
      }
    },
    loadData () {
      this.$store.dispatch('mutateCommonProperties', { loading: true })
      const params = Object.assign({}, this.search, { page: this.pagination.currentPage, per_page: this.pagination.perPage })
      this.$store.dispatch('mutateCommonProperties', { loading: true, listReload: false })
      RestApi.getData(trainingElearningServiceBaseUrl, allowanceListApi, params).then(response => {
        if (response.success) {
          this.$store.dispatch('setList', response.data.data)
          this.paginationData(response.data)
        } else {
          this.$store.dispatch('setList', [])
        }
        this.$store.dispatch('mutateCommonProperties', { loading: false, listReload: false })
      })
    },
    getMomoList (fiscalYearId) {
      return this.$store.state.TrainingElearning.commonObj.circularMemoList.filter(item => item.fiscal_year_id === fiscalYearId).map(item => {
        if (this.$i18n.locale === 'bn') {
          return { value: item.value, text: item.text_bn }
        } else {
          return { value: item.value, text: item.text_en }
        }
      })
    },
    getTrainingTitle (circularMemoId) {
      const trainingObj = this.$store.state.TrainingElearning.commonObj.circularMemoList.find(item => item.value === circularMemoId)
      return this.$store.state.TrainingElearning.commonObj.trainingNameList.filter(item => item.status === 1 && item.value === trainingObj.training_title_id).map(item => {
        if (this.$i18n.locale === 'bn') {
          return { value: item.value, text: item.text_bn }
        } else {
          return { value: item.value, text: item.text_en }
        }
      })
    },
    getFiscalYear (fiscalYearId) {
      const fiscalObj = this.fiscalYearList.find(item => item.value === fiscalYearId)
      return fiscalObj.text
    },
    getCircularMemo (circularMemoId) {
      const circularObj = this.$store.state.TrainingElearning.commonObj.circularMemoList.find(item => item.value === circularMemoId)
      if (this.$i18n.locale === 'bn') {
        return circularObj.text_bn
      } else {
        return circularObj.text_en
      }
    },
    getTraining (trainingId) {
      const trainingObj = this.$store.state.TrainingElearning.commonObj.trainingNameList.find(item => item.value === trainingId)
      if (this.$i18n.locale === 'bn') {
        return trainingObj.text_bn
      } else {
        return trainingObj.text_en
      }
    },
    getBatch (batchId) {
      const batchObj = this.$store.state.TrainingElearning.commonObj.batchList.find(item => item.value === batchId)
      if (this.$i18n.locale === 'bn') {
        return batchObj.text_bn
      } else {
        return batchObj.text_en
      }
    }
  }
}
</script>
<style scoped>
.overlay {
    position: absolute;
    left: 65%;
    z-index: 9999;
    top: 10px;
    text-align: center;
}
</style>
